export const ORDER_CUSTOMER_EXPORT_ID = 'order-customer';
export const ORDER_CUSTOMER_TITLE = 'Pedidos de Clientes';

export const ORDER_DELIVERY_INCOMPLETE_ID = 'order-delivery-incomplete';
export const ORDER_DELIVERY_INCOMPLETE_TITLE= 'Entregas Incompletas';

export const ORDER_CHARGE_IN_OUT_EXPORT_ID = 'order-charge-in-out';
export const ORDER_CHARGE_IN_OUT_TITLE = 'R. Cargas In-Out';

export const ORDER_DELIVERY_EXPORT_ID = 'order-delivery';
export const ORDER_DELIVERY_TITLE= 'R. de Entregas';

export const ORDER_INVOICE_EXPORT_ID = 'order-invoice';
export const ORDER_INVOICE_TITLE = 'Facturas de Clientes';

export const ORDER_RETURN_EXPORT_ID = 'order-return-product';
export const ORDER_RETURN_TITLE = 'Hist. de Devol. de Prod.';

export const ORDER_CHANGE_EXPORT_ID = 'order-change-product';
export const ORDER_CHANGE_TITLE = 'Hist. de Camb. de Prod.';

export const ORDER_SELLER_EXPORT_ID = 'order-seller';
export const ORDER_SELLER_TITLE = 'Pedidos de Vendedor';

export const NECESSITY_EXPORT_ID = 'total-necessity';
export const NECESSITY_TITLE = 'Necesidad Total';

export const ORDER_LOSS_EXPORT_ID = 'order-loss-product';
export const ORDER_LOSS_TITLE = 'Mermas';

export const LOCALIZED_PROPERTIES = {
  code: 'Codigo_Ruta',
  subRoute: 'Ruta',
  tripCode: 'Codigo_Viaje', //loss
  trip: 'Viaje', //loss
  user: 'Usuario',
  serials: 'Nro Doc',
  externalCode: 'Nro Doc Externo',
  date: 'Fecha',
  returnTypeCode: 'Código de Tipo de Devolución',
  returnTypeName: 'Nombre de Tipo de Devolución',
  shipToExternalKey:'Codigo_Cliente',
  shipToName: 'Cliente',
  NIT: 'NIT',
  soldToExternalKey: 'Codigo_Pagador', //loss
  soldToName: 'Pagador', //loss
  materialCode: 'Codigo_Material',
  materialName: 'Material',
  soldQuantity: 'Cantidad',
  baseUnitOfMeasureCode: 'UMB',
  pararellQuantity: 'Cantidad UMP',
  pararellUnitOfMeasureCode: 'UMP',
  unitPrice: 'Precio',
  subTotal: 'Subtotal',
  status: 'Anulada',
  total: 'Total'
};

export const LOCALIZED_NECESSITY = {
  materialCode: 'Codigo_Material',
  materialName: 'Material',
  baseQuantity: 'Cantidad Solicitada',
  baseUnitOfMeasureCode: 'UMB',
  pararellQuantity: 'Cantidad UMP',
  pararellUnitOfMeasureCode: 'UMP',
  stockConfirmedBase: 'Cantidad Confirmada',
  stockbaseUnitOfMeasureCode:'UMB',
  stockConfirmedPararell: 'Cantidad UMP',
  stockpararellUnitOfMeasureCode: 'UMP',
};